/**
 * Panier de PAC (BAR-TH-178/179/180, BAT-TH-162/163/164) pour les simulateurs « Market » (entreprise, copropriété,
 * iframe) : même comportement que le bloc PRO de global_simulator.js (affichage Etas / COP selon la puissance,
 * coches d'usage, lignes ajoutables, saisie numérique, contrôle somme des PAC <= puissance de la chaufferie).
 *
 * Usage : const toggle = initPacBasket(function () { return <id de la fiche sélectionnée>; }); toggle();
 */
module.exports = function initPacBasket(getSelectedWorkId) {
    var PAC_WORK_IDS = [349, 350, 351, 352, 353, 354];
    var PAC_POWER_THRESHOLD = 400; // kW : <= 400 → Etas, > 400 → COP
    var PAC_WORK_IDS_USAGE_PER_PAC = [350, 351]; // 179 / 180 : Etas seul (pas de COP) + usage choisi pour chaque PAC
    var PAC_WORK_IDS_USAGE_CHECKS = [349, 352]; // 178 / 162 : coches d'usage du système
    var PAC_TOTAL_MESSAGE = 'La puissance totale de la chaufferie après travaux doit être supérieur ou égale à la somme de la puissance des PAC installées';

    // Affiche l'Etas (P <= 400 kW ou non saisie) ou le COP (P > 400 kW) et n'active que le champ affiché
    var syncPacRow = function ($row) {
        var power = parseFloat(String($row.find('.pac162-power').val()).replace(',', '.'));
        var $etas = $row.find('.pac162-etas-container');
        var $cop = $row.find('.pac162-cop-container');
        var $usage = $row.find('.pac162-usage-container');
        var usageMode = $('#PAC_SECTION').hasClass('pac162-usage-mode');
        // Puissance non saisie : ni Etas ni COP (on ne sait pas encore lequel s'applique)
        var hasPower = !isNaN(power);
        // Fiche sans COP (BAR-TH-179 / 180) : l'Etas s'applique quelle que soit la puissance
        var isCop = hasPower && !usageMode && power > PAC_POWER_THRESHOLD;
        var showEtas = hasPower && !isCop;
        var rowActive = $row.is(':visible');
        // Sans puissance, l'Etas reste masqué mais garde sa place (visibility) pour ne pas décaler les colonnes
        $etas.toggle(showEtas || !hasPower).css('visibility', hasPower ? 'visible' : 'hidden');
        $cop.toggle(isCop);
        $etas.find('input').prop('disabled', !rowActive || !showEtas);
        $cop.find('input').prop('disabled', !rowActive || !isCop);
        $usage.toggle(usageMode);
        $usage.find('input').prop('disabled', !rowActive || !usageMode);
    };

    // Contrôle : somme des puissances des PAC <= puissance totale de la chaufferie après travaux
    var checkPacTotal = function () {
        var $container = $('#P3_CHAUFF_TOT_POWER');
        if (!$container.length) return;

        var $message = $container.find('.pac162-total-error');
        var sum = 0;
        if ($('#PAC_SECTION').is(':visible')) {
            $('#PAC_SECTION .pac162-row:visible .pac162-power').each(function () {
                var value = parseFloat(String($(this).val()).replace(',', '.'));
                if (!isNaN(value)) sum += value;
            });
        }
        var chauffage = parseFloat(String($container.find('input').first().val()).replace(',', '.'));

        if (sum > 0 && !isNaN(chauffage) && chauffage < sum) {
            if (!$message.length) {
                $message = $('<div class="pac162-total-error"></div>').text(PAC_TOTAL_MESSAGE)
                    .css({color: 'red', fontSize: '13px', fontWeight: 800, margin: '5px 0 0'});
                $container.append($message);
            }
        } else {
            $message.remove();
        }
    };

    var toggleSection = function () {
        var section = $('#PAC_SECTION');
        if (!section.length) return;

        var workId = getSelectedWorkId();
        if ($.inArray(workId, PAC_WORK_IDS) === -1) {
            section.hide();
            section.find('input, select').attr('disabled', 'disabled');
            return;
        }

        section.toggleClass('pac162-usage-mode', $.inArray(workId, PAC_WORK_IDS_USAGE_PER_PAC) !== -1);
        var usageChecks = $.inArray(workId, PAC_WORK_IDS_USAGE_CHECKS) !== -1;
        $('#PAC_USAGES').toggle(usageChecks);
        // Chauffage reste verrouillé (toujours coché) ; ECS / rafraîchissement actifs uniquement pour 178 / 162
        $('.pac162-usage-cb').not('[data-target="PAC_USG_CHAUF"]').prop('disabled', !usageChecks);
        section.show();
        section.find('.pac162-row').each(function () {
            var $row = $(this);
            $row.find('.pac162-power').prop('disabled', !$row.is(':visible'));
            syncPacRow($row);
        });
        checkPacTotal();
    };

    // Puissance, Etas, COP : chiffres uniquement, avec un seul séparateur décimal (virgule ou point)
    $(document).on('input', '.pac162-number', function () {
        var cleaned = $(this).val().replace(/[^0-9.,]/g, '');
        var firstSeparator = cleaned.search(/[.,]/);
        if (firstSeparator !== -1) {
            cleaned = cleaned.slice(0, firstSeparator + 1) + cleaned.slice(firstSeparator + 1).replace(/[.,]/g, '');
        }
        if (cleaned !== $(this).val()) {
            $(this).val(cleaned);
        }
    });

    $(document).on('input change', '.pac162-power, #P3_CHAUFF_TOT_POWER input', checkPacTotal);

    $(document).on('input change', '.pac162-power', function () {
        syncPacRow($(this).closest('.pac162-row'));
    });

    $(document).on('change', '.pac162-usage-cb', function () {
        $('[name*="[' + $(this).data('target') + ']"]').val($(this).is(':checked') ? 1 : 0);
    });

    $('#pac162-add-row').on('click', function () {
        var next = $('.pac162-row-extra:hidden').first();
        if (next.length) {
            next.show();
            next.find('.pac162-power').prop('disabled', false);
            syncPacRow(next);
        }
        if (!$('.pac162-row-extra:hidden').length) {
            $(this).hide();
        }
    });

    $(document).on('click', '.pac162-row-remove', function () {
        var row = $(this).closest('.pac162-row');
        row.find('input[type=radio]').prop('checked', false);
        row.find('input:not([type=radio])').val('');
        row.hide();
        row.find('input').attr('disabled', 'disabled');
        $('#pac162-add-row').show();
        setTimeout(checkPacTotal, 0);
    });

    return toggleSection;
};
